export default __webpack_public_path__ + "static/media/porfirio26bb.366bb3c9.jpg";